module.exports = __webpack_public_path__ + "static/img/a-i-limiter_256.2f37bb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/a-i-limiter_256.png
// module id = O1/o
// module chunks = 0